import { inject, Injectable } from '@angular/core';
import { ApiSchema } from './http-api-schema';
import { forkJoin, map, Observable } from 'rxjs';
import { NgxTranslatorService } from '@adapter/i18n/ngx-translator.service';
import { interpolateStr } from '@common/string-utils';

/**
 * Clase decoradora que se encarga de traducir los mensajes que vienen en la respuesta de la API.
 */
@Injectable({
  providedIn: 'root'
})
export class HttpTranslatorDecorator {
  private translateService = inject(NgxTranslatorService);

  /**
   * Traduce los mensajes de la respuesta de la API.
   */
  translate<T>(schema: ApiSchema<T>): Observable<ApiSchema<T>> {
    const translationTasks$: Observable<string>[] = [];

    translationTasks$.push(this.translateService.getAsync(schema.message));

    if (schema.errors && schema.errors.length > 0) {
      schema.errors.forEach((error) => {
        translationTasks$.push(
          this.translateService
            .getAsync(error.message)
            .pipe(
              map((translatedMessage: string) =>
                interpolateStr(translatedMessage, error.fields)
              )
            )
        );
      });
    }

    return new Observable((observer) => {
      forkJoin(translationTasks$).subscribe((translations) => {
        const newSchema = {
          ...schema
        } as ApiSchema<T>;
        newSchema.message = translations[0];
        for (let i = 0; i < schema.errors!.length; i++) {
          newSchema.errors![i].key = schema.errors![i].message;
          newSchema.errors![i].message = translations[i + 1];
          newSchema.errors![i].fields = schema.errors![i].fields;
        }
        observer.next(newSchema);
        observer.complete();
      });
    });
  }
}
